import { useEffect, useState } from "react";
import { api } from "../../api";
import { navigate } from "../../lib/router";
import { Helmet } from "react-helmet-async";
import type { BlogPost } from "../../types";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import * as utils from "../../lib/utils";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from "../../components/ui/card";
import Navbar from "../../components/Navbar";
import { formatDate } from "../utils/date";

export function BlogPage() {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [query, setQuery] = useState("");
  const fixImageUrl =
    (utils as { fixImageUrl?: (url: string) => string; default?: { fixImageUrl?: (url: string) => string } })
      .fixImageUrl ||
    utils.default?.fixImageUrl ||
    ((url: string) => url);

  useEffect(() => {
    (async () => {
      const res = await api.listBlogPosts();
      if (res.ok) setPosts(res.data);
    })();
  }, []);

  const filtered = posts.filter(p =>
    p.title.toLowerCase().includes(query.toLowerCase()),
  );

    return (
      <div className="min-h-screen w-full flex flex-col bg-white text-neutral-900">
        <Helmet>
          <title>Blog</title>
        </Helmet>
        <Navbar />
        <div className="max-w-screen-xl mx-auto flex-1 px-4">
          <div className="mb-12 flex flex-col items-center text-center gap-6">
        <h1 className="text-5xl font-extrabold text-gray-900 leading-tight">
          Blog
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl">
          Descubra artigos interessantes e atualizações recentes. Navegue por
          diversos temas e explore conteúdos que vão te inspirar!
        </p>
        <div className="relative max-w-md w-full">
          <Input
            placeholder="Pesquisar..."
            value={query}
            onChange={e => setQuery(e.target.value)}
            className="border-2 border-gray-300 rounded-md p-3 pr-10 w-full focus:outline-none focus:ring-2 focus:ring-[#71B27B] text-lg"
          />
          <span className="absolute top-1/2 transform -translate-y-1/2 right-3 text-gray-500">
            <i className="fas fa-search"></i>
          </span>
        </div>
        </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map(post => {
          const excerpt =
            post.subtitle ||
            post.content.find(b => b.type === "text")?.text.slice(0, 120) ||
            "";
          const date = post.created_at ? formatDate(post.created_at) : null;
          return (
            <Card
              key={post.id}
              className="flex flex-col overflow-hidden rounded-lg shadow-lg transition-transform transform hover:scale-105"
            >
              {post.meta_image && (
                <img
                  src={fixImageUrl(post.meta_image)}
                  alt={post.meta_title || post.title}
                  className="h-48 w-full object-cover rounded-t-lg"
                />
              )}
              <CardHeader className="bg-white p-4">
                {date && (
                  <p className="text-sm text-muted-foreground mb-2">{date}</p>
                )}
                <CardTitle className="text-xl font-semibold text-gray-900">
                  {post.title}
                </CardTitle>
                {post.subtitle && (
                  <CardDescription className="text-gray-600">
                    {post.subtitle}
                  </CardDescription>
                )}
              </CardHeader>
              <CardFooter className="mt-auto p-4 bg-gray-50">
                <Button
                  variant="secondary"
                  onClick={() => navigate(`/blog/${post.slug}`)}
                  className="w-full py-2"
                >
                  Leia mais
                </Button>
              </CardFooter>
            </Card>
          );
        })}
          </div>
        </div>
      </div>
    );
  }

export default BlogPage;
